import api from './api';

export const getMyProponentProfile = () => api.get('/api/proponents/me');
export const upsertMyProponentProfile = (data) => api.put('/api/proponents/me', data);
export const listProponents = () => api.get('/api/proponents');
